// File path: /core/frontend/src/aws-config.js
// Shared AWS Configuration for all modules

const awsConfig = {
  // Cognito
  Auth: {
    region: process.env.REACT_APP_AWS_REGION || 'us-west-2',
    userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-west-2_Wura8mtGp',
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '1vcaa0uqid2velsejl5505s025',
    authenticationFlowType: 'USER_SRP_AUTH',
    oauth: {
      domain: process.env.REACT_APP_COGNITO_DOMAIN || 'https://us-west-2wura8mtgp.auth.us-west-2.amazoncognito.com',
      scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
      redirectSignIn: process.env.REACT_APP_REDIRECT_SIGN_IN || (
        process.env.NODE_ENV === 'development'
          ? 'http://localhost:3000/'
          : 'https://dev.lumilearn.app/'
      ),
      redirectSignOut: process.env.REACT_APP_REDIRECT_SIGN_OUT || (
        process.env.NODE_ENV === 'development'
          ? 'http://localhost:3000/'
          : 'https://dev.lumilearn.app/'
      ),
      responseType: 'code'
    }
  },
  // API Gateway
  API: {
    endpoints: [
      {
        name: 'LumiLearnAPI',
        endpoint: 'https://dev.api.lumilearn.app',
        region: process.env.REACT_APP_AWS_REGION || 'us-west-2'
      }
    ]
  },
  // S3 Storage
  Storage: {
    AWSS3: {
      bucket: process.env.REACT_APP_S3_BUCKET || 'lumilearn-elevate-core',
      region: process.env.REACT_APP_AWS_REGION || 'us-west-2'
    }
  }
};

export default awsConfig;
